export default __webpack_public_path__ + "static/media/background.eb205376.jpg";